import { Alert, Typography, alertClasses, buttonClasses, svgIconClasses, buttonBaseClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../../../../../utils/withDefaults';
import { spreadTypography } from '../../../../../../utils/typeUtils';
const RootRoot = styled(Alert, {
  shouldForwardProp: name => name !== 'oneLine'
})(({
  theme,
  oneLine
}) => ({
  padding: theme.spacing(1),
  [`& .${alertClasses.action}`]: {
    alignSelf: 'flex-start',
    padding: oneLine ? theme.spacing(0) : theme.spacing(0, 0.5, 1, 1),
    [`& .${buttonClasses.root}`]: {
      width: 24,
      height: 24
    }
  },
  [`& .${alertClasses.icon}`]: {
    alignSelf: oneLine ? 'center!important' : 'flex-start'
  },
  [`& .${svgIconClasses.root}`]: {
    width: 24,
    height: 24
  },
  [`& .${buttonBaseClasses.root}`]: {
    margin: oneLine ? theme.spacing(0, 1, 0, 1) : theme.spacing(1),
    padding: theme.spacing(0.25)
  }
}));
export const Root = withDefaults(RootRoot, {
  severity: 'warning'
});
const WarningTitleRoot = styled(Typography)();
export const WarningTitle = withDefaults(WarningTitleRoot, {
  variant: 'Lato Caption Bold'
});
const WarningMessageRoot = styled(Typography)({});
export const WarningMessage = withDefaults(WarningMessageRoot, {
  variant: 'Lato Caption'
});
export const Link = styled('a')(({
  theme
}) => ({
  ...spreadTypography(theme.typography['Lato Caption Bold']),
  lineHeight: theme.spacing(3),
  textDecoration: 'underline',
  display: 'inline',
  cursor: 'pointer',
  wordBreak: 'keep-all'
}));